import { render, staticRenderFns } from "./ListaNivel.vue?vue&type=template&id=5573155a&scoped=true&"
import script from "./ListaNivel.vue?vue&type=script&lang=js&"
export * from "./ListaNivel.vue?vue&type=script&lang=js&"
import style0 from "./ListaNivel.vue?vue&type=style&index=0&id=5573155a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5573155a",
  null
  
)

export default component.exports